export default {
      id: "snapshot-white-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#snapshot-white-usage",
      toString: function () {
        return this.url;
      }
    }